<script setup>
import { useI18n } from "vue-i18n";

const { t } = useI18n();

useSeoMeta({
  title: () => t('seo.greenline.title'),
  description: () => t('seo.greenline.description'),
  ogTitle: () => t('seo.greenline.title'),
  ogDescription: () => t('seo.greenline.description'),
});

const plaquesFotovoltaiques = [
  {
    name: t("greenline_module.plaques.first_title"),
    description: t("greenline_module.plaques.first_description"),
  },
  {
    name: t("greenline_module.plaques.second_title"),
    list: [
      {
        item: t("greenline_module.plaques.second_item_1"),
      },
      {
        item: t("greenline_module.plaques.second_item_2"),
      },
      {
        item: t("greenline_module.plaques.second_item_3"),
      },
    ],
  },
  {
    name: t("greenline_module.plaques.third_title"),
    description: t("greenline_module.plaques.third_description"),
  },
];

const economiaCircular = [
  {
    name: t("greenline_module.economia.first_title"),
    description: t("greenline_module.economia.first_description"),
  },
  {
    name: t("greenline_module.economia.second_title"),
    list: [
      {
        item: t("greenline_module.economia.second_item_1"),
      },
      {
        item: t("greenline_module.economia.second_item_2"),
      },
      {
        item: t("greenline_module.economia.second_item_3"),
      },
    ],
  },
  {
    name: t("greenline_module.economia.third_title"),
    list: [
      {
        item: t("greenline_module.economia.third_item_1"),
      },
      {
        item: t("greenline_module.economia.third_item_2"),
      },
      {
        item: t("greenline_module.economia.third_item_3"),
      },
      {
        item: t("greenline_module.economia.third_item_4"),
      },
    ],
  },
];
</script>

<template>
  <div>
    <Menu />
    <div class="mb-20 lg:mb-40">
      <div class="max-w-7xl mx-auto p-6 lg:px-8">
        <SectionHeader :firstLabel="$t('greenline_module.title_first_label')"
          :secondLabel="$t('greenline_module.title_second_label')"></SectionHeader>
      </div>

      <div class="mt-8 sm:mt-6 xl:mx-auto xl:max-w-7xl xl:px-8">
        <AppImage src="/img/greenline/plaques-fotovoltaiques-header" priority
          class="xl:rounded-3xl overflow-hidden" img-class="aspect-[9/4] w-full object-cover"
          sizes="(min-width: 1280px) 1280px, 100vw" />
      </div>

      <div class="mx-auto mt-8 max-w-7xl px-6 sm:mt-10 lg:px-8">
        <div class="mx-auto max-w-2xl lg:mx-0">
          <h2 class="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">
            {{ $t("greenline_module.plaques.title") }}
          </h2>
          <p class="mt-6 text-lg leading-8 text-gray-600">
            {{ $t("greenline_module.plaques.description") }}
          </p>
        </div>
        <dl
          class="mx-auto mt-16 grid max-w-2xl grid-cols-1 gap-x-8 gap-y-16 text-base leading-7 sm:grid-cols-2 lg:mx-0 lg:max-w-none lg:grid-cols-3">
          <div v-for="value in plaquesFotovoltaiques" :key="value.name">
            <dt class="font-semibold text-gray-900">{{ value.name }}</dt>
            <dd class="mt-1 text-gray-600" v-if="value.description">
              {{ value.description }}
            </dd>
            <div v-if="value.list">
              <dd class="mt-1 text-gray-600" v-for="item in value.list">
                {{ item.item }}
              </dd>
            </div>
          </div>
        </dl>
      </div>

      <div class="mx-auto mt-8 max-w-7xl px-6 sm:mt-10 lg:px-8">
        <div class="mx-auto max-w-2xl lg:mx-0">
          <h2 class="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">
            {{ $t("greenline_module.economia.title") }}
          </h2>
          <p class="mt-6 text-lg leading-8 text-gray-600">
            {{ $t("greenline_module.economia.description") }}
          </p>
        </div>
        <dl
          class="mx-auto mt-16 grid max-w-2xl grid-cols-1 gap-x-8 gap-y-16 text-base leading-7 sm:grid-cols-2 lg:mx-0 lg:max-w-none lg:grid-cols-3">
          <div v-for="value in economiaCircular" :key="value.name">
            <dt class="font-semibold text-gray-900">{{ value.name }}</dt>
            <dd class="mt-1 text-gray-600" v-if="value.description">
              {{ value.description }}
            </dd>
            <div v-if="value.list">
              <dd class="mt-1 text-gray-600" v-for="item in value.list">
                {{ item.item }}
              </dd>
            </div>
          </div>
        </dl>
      </div>
    </div>
    <Footer />
  </div>
</template>
